import React from 'react';
import { connect } from 'react-redux';
import {closeModal, returnToLobby, saveToHistory } from '../cellcomAbroadBlockSlice';
import {otpValidationPopupContent} from '../cellcomAbroadVariables';
import {Container} from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import PopupButtonAsLinkComponent from './PopupSharedComponents/PopupButtonAsLinkComponent';
import CallBackComponent from './PopupSharedComponents/CallBackComponent';


const AccountSegmentMatchSocPopupComponent = (props) => {

    const returnToAbroadLobby = () => {
        props.closeModal();
        props.saveToHistory()
        props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
        props.returnToLobby();
    }

    return (
       
        <Container>
            <PopupHeadlineComponent title = {otpValidationPopupContent.accountSegmentMatchSoc.headline}/>
            <PopupDescriptionComponent boldDescription = {otpValidationPopupContent.accountSegmentMatchSoc.descriptionBold} />
            <PopupButtonAsLinkComponent text={`  ניתן לבחור חבילה אחרת > `} onClick = {()=> returnToAbroadLobby()}/>
            <CallBackComponent  isBusiness = {false} />
         </Container>
    )
}

const mapStateToProps = (state) => {
    return {
        data: state.cellcomAbroad,
    };
};

const mapDispatchToProps = {
    closeModal,
    returnToLobby,
    saveToHistory 
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSegmentMatchSocPopupComponent);